/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetDocumentViewHistoriesResponseData,
  GetDocumentViewHistoriesResponseDataFromJSON,
  GetDocumentViewHistoriesResponseDataFromJSONTyped,
  GetDocumentViewHistoriesResponseDataToJSON
} from './GetDocumentViewHistoriesResponseData'

/**
 *
 * @export
 * @interface GetDocumentViewHistoriesResponse
 */
export interface GetDocumentViewHistoriesResponse {
  /**
   *
   * @type {number}
   * @memberof GetDocumentViewHistoriesResponse
   */
  status?: number
  /**
   *
   * @type {GetDocumentViewHistoriesResponseData}
   * @memberof GetDocumentViewHistoriesResponse
   */
  data?: GetDocumentViewHistoriesResponseData
}

export function GetDocumentViewHistoriesResponseFromJSON(json: any): GetDocumentViewHistoriesResponse {
  return GetDocumentViewHistoriesResponseFromJSONTyped(json, false)
}

export function GetDocumentViewHistoriesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetDocumentViewHistoriesResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetDocumentViewHistoriesResponseDataFromJSON(json['data'])
  }
}

export function GetDocumentViewHistoriesResponseToJSON(value?: GetDocumentViewHistoriesResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetDocumentViewHistoriesResponseDataToJSON(value.data)
  }
}
